import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '../../lib/cn';

// Всплывающая панель у контрола: выбор канала ответа над полем в диалогах.
//
// Единственный новый примитив, заведённый под эту задачу (`.tasks/dialogs-reply-channel.md`).
// Собственная реализация тут не подошла: нужен возврат фокуса на триггер, закрытие по Esc и
// клику снаружи, отслеживание края экрана - всё это Radix делает правильно, а руками
// переписывается с ошибками, которые видны только со скринридером.
//
// Оформление - из токенов: скруглённый белый лист с всплывающей тенью, как в прототипе.

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

export const PopoverContent = forwardRef<
  ElementRef<typeof PopoverPrimitive.Content>,
  ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'start', side = 'top', sideOffset = 8, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      side={side}
      sideOffset={sideOffset}
      collisionPadding={12}
      data-slot="popover"
      // Классов анимации из tailwindcss-animate тут намеренно нет: плагин в проект не
      // подключён, и такие утилиты просто не сгенерировались бы.
      className={cn(
        'z-50 rounded-lg border border-line bg-panel p-1.5 text-text shadow-pop outline-none',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
